import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mesAnteriorNumerico',
})
export class MesAnteriorNumericoPipe implements PipeTransform {
  transform(fecha: Date | string): string {
    const date = new Date(fecha);
    const mesAnterior = new Date(date.getFullYear(), date.getMonth(), 1);
    const mes = (mesAnterior.getMonth() + 1).toString().padStart(2, '0');
    const anho = mesAnterior.getFullYear();
    return `${mes}/${anho}`;
  }
}
